import React from 'react';
import PropTypes from 'prop-types';
import { DateFormatTypes } from '@vp/om-date-formatter';
import Date from './Date';
import useSiteData from '../../hooks/useSiteData';

const DateRange = ({
  start,
  end,
  dateFormatType = DateFormatTypes.SHORT_FMT,
}) => {
  const { locale } = useSiteData();
  return (
    <span>
      <Date date={start} locale={locale} formatType={dateFormatType} />
      {' - '}
      <Date date={end} locale={locale} formatType={dateFormatType} />
    </span>
  );
};

DateRange.propTypes = {
  start: PropTypes.string,
  end: PropTypes.string,
  dateFormatType: PropTypes.string,
};

export default DateRange;
